import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  color: ${({ theme }) => theme.palette.text.secondary};
  ${({ theme }) => typographyToCss(theme.typography.caption)};
`;

export const BreadcrumbItem = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)}
  display: flex;
  align-items: center;

  & > a {
    text-decoration: none;
    color: inherit;
    transition: ${({ theme }) => theme.transitions.create('color')};
    display: flex;
    align-items: center;

    &:hover {
      color: ${({ theme }) => theme.palette.text.primary};
      text-decoration: underline;
    }
  }
`;

export const IconWrapper = styled.span`
  margin-right: ${({ theme }) => theme.spacing(1)};
  display: flex;
  align-items: center;
`;

export const Separator = styled.span`
  color: ${({ theme }) => theme.palette.grey[600]};
  user-select: none;
  display: flex;
  align-items: center;
`;
